var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"title",rawName:"v-title"}],class:[{ 'app-mourn': _vm.isMourn }],attrs:{"id":"app","data-title":_vm.meteTitle}},[_c('router-view',{key:_vm.$route.fullPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }